
import { defineComponent } from 'vue';
import { baseUrl } from '@/utils/constants';

export default defineComponent({
  name: 'CompanyProfile',
  data() {
    return {
      baseUrl
    };
  },
  props: {
    first: {
      required: true,
      default: () => {
        return null;
      }
    },
    loaded: {
      required: true,
      type: Boolean,
      default: false
    }
  }
});
